var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgMagnifyGlassGrey = function SvgMagnifyGlassGrey(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 136,
    viewBox: "0 0 122 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122 55.6762C122 83.9685 100.606 107.153 73.0904 110.072H73.0343C71.125 110.24 69.2158 110.352 67.3066 110.352C56.0759 110.352 55.9636 110.352 55.9636 110.352C55.9636 110.352 55.9636 110.072 55.9636 109.623C85.7249 109.623 109.871 85.4842 109.871 55.6762C109.871 25.9242 85.7249 1.7859 55.9636 1.7859C55.9636 1.50522 55.9636 1 55.9636 1C55.9636 1 56.4129 1 67.3066 1C97.5171 1 122 25.4752 122 55.6762Z",
    fill: "#EBEEF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9634 109.623C85.7665 109.623 109.927 85.4699 109.927 55.6762C109.927 25.8824 85.7665 1.72977 55.9634 1.72977C26.1602 1.72977 2 25.8824 2 55.6762C2 85.4699 26.1602 109.623 55.9634 109.623Z",
    stroke: "#A9B2BD",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.247 134.154L80.7272 103.729",
    stroke: "#A9B2BD",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3542 65.893C56.3963 65.893 55.605 64.8264 55.605 63.5353V26.7103C55.605 25.4192 56.3963 24.3526 57.3542 24.3526C58.3121 24.3526 59.1034 25.4192 59.1034 26.7103V63.5353C59.1451 64.8264 58.3537 65.893 57.3542 65.893Z",
    fill: "#697684"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3542 85.0565C56.3963 85.0565 55.605 83.9899 55.605 82.6988V75.5695C55.605 74.2784 56.3963 73.2119 57.3542 73.2119C58.3121 73.2119 59.1034 74.2784 59.1034 75.5695V82.6988C59.1451 83.9899 58.3537 85.0565 57.3542 85.0565Z",
    fill: "#697684"
  })));
};
var Memo = /*#__PURE__*/memo(SvgMagnifyGlassGrey);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "assets/illustrations/MagnifyGlassGrey.bdfe959eaf184096657d9df3d1e20f16.svg";